/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Cameras
 */

module.exports = {

    Controls: require('./controls'),
    Scene2D: require('./2d'),
    Sprite3D: require('./sprite3d')

};



//////////////////
// WEBPACK FOOTER
// ./cameras/index.js
// module id = 466
// module chunks = 0